import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const StoreBadgeListTitle = styled.div`
  ${media.smallOnly`
    display: none;
  `}
`;
